// eslint-disable-next-line
import React, { useState } from 'react';
import './ForgetPassword.css';
import { Box, Typography } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { ArrowLeft, Mail } from 'lucide-react';
import LogoImage from '../../../assets/Admin/AdminNavbar/logo-image.png';
import Layout from '../../../components/Layout';
import { useNavigate } from 'react-router-dom';

const ForgetPassword = () => {
  const [userEmail, setUserEmail] = useState('');
  const [validateEmail, setValidateEmail] = useState(false);
  const [successMessage, setSuccessMesssage] = useState(false);
  const navigate = useNavigate();

  const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL;

  // Validation state
  const isEmailValid = userEmail.trim() !== '';

  const handleUserEmailChange = e => {
    setUserEmail(e.target.value);
    setValidateEmail(false);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!isEmailValid) {
      toast.dismiss();
      toast.error('Please enter your email address');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(userEmail)) {
      toast.error('Please enter a valid email address');
      return;
    }

    try {
      const res = await axios.post(`${SERVER_API_URL}/auth/forgot-password`, {
        email: userEmail,
      });
      if (res.status === 200) {
        setValidateEmail(false);
        setSuccessMesssage(true);
      }
    } catch (error) {
      console.log(error);
      setValidateEmail(true);
    }
  };

  const handleBackArrowClick = () => {
    navigate('/');
  };

  return (
    <Layout title="Klass Online | Forgot Password">
      <Box className="forget-password-container">
        {/* Header Section */}
        <Box className="forget-password-header">
          <Box className="back-button-container">
            <button onClick={handleBackArrowClick} className="back-button">
              <ArrowLeft className="back-icon" />
            </button>
          </Box>

          <Box className="forget-password-logo">
            <img src={LogoImage} alt="Klass Online Logo" className="logo-image" />
          </Box>

          {!successMessage ? (
            <>
              <Typography variant="h3" className="forget-password-title">
                Forgot Password
              </Typography>
              <Typography variant="body1" className="forget-password-subtitle">
                We'll send you a reset password link to your email address.
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h3" className="forget-password-title">
                Check Your Email
              </Typography>
              <Typography variant="body1" className="forget-password-subtitle">
                We've sent password recovery instructions to your email address.
              </Typography>
            </>
          )}
        </Box>

        {/* Main Card */}
        <Box className="forget-password-card">
          {!successMessage ? (
            <form className="forget-password-form" onSubmit={e => handleSubmit(e)}>
              <Box className="input-group">
                <label htmlFor="email" className="input-label">
                  Email Address
                </label>
                <Box className="input-container">
                  <Mail className="input-icon" />
                  <input
                    id="email"
                    className="input-field"
                    type="email"
                    placeholder="admin@example.com"
                    value={userEmail}
                    onChange={handleUserEmailChange}
                    required
                  />
                </Box>
                {validateEmail && (
                  <div className="error-message">
                    We are unable to find an account associated with this email address. Please
                    check if the email you have provided is correct or contact your administrator
                    for assistance.
                  </div>
                )}
              </Box>

              <button
                type="submit"
                className={`primary-button ${!isEmailValid ? 'disabled' : ''}`}
                disabled={!isEmailValid}
              >
                Send Reset Link
              </button>
            </form>
          ) : (
            <Box className="success-content">
              <Box className="success-icon">
                <Mail className="success-icon-svg" />
              </Box>
              <Typography variant="body1" className="success-message">
                If an account with that email exists, you will receive password recovery
                instructions shortly.
              </Typography>
              <button onClick={() => navigate('/')} className="primary-button">
                Back to Login
              </button>
            </Box>
          )}
        </Box>
      </Box>
    </Layout>
  );
};

export default ForgetPassword;
